const cta = {
    'es':'Volver',
    'en':'Back'
}

export default cta;